import React from 'react';
import { observer } from 'mobx-react';
import {
  CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, AreaChart, Area
} from 'recharts';

import styles from './widgets.module.css';
import dashboardStore from '../../../stores/dashboard.store';
import memberStore from '../../../stores/member.store';
import { StatDeviceSum, statUnitLabel } from '../../../models/stat.model';
import { GraphTimeTick } from '../../common/graph_time_tick.component';
import ChartTooltip, { axisTickStyle, Coordinates } from './chart_tooltip.component';
import { deployMarkerLines } from './deploy_markers';

const deviceDataColors = ['#7becef','#21a1b5','#ffa7b6','#ffe38b','#e51a41','#b3e528','#ff7a06','#48f9a0','#11d472',
  '#bbbbbb','#ffc68d','#adf9fa','#ffdd34', '#ac40b2','#ebffb4','#ffc306', '#808080','#f45179','#ff8e1d']

const DeviceChartWidget = observer(() => {
  const { deviceSums, version, appVersions } = dashboardStore;
  const unitLabel = statUnitLabel(memberStore.app?.platform);

  let deviceData = deviceSums.slice(); // linechart is checking if it is an array and it isn't because of mobx
  const versions = version.length > 0 ? [version] : appVersions.slice();
  const showVersions = versions.slice(0, deviceDataColors.length - 1);
  let hasOther = false;
  deviceData = deviceData.map(data => {
    const tempData: StatDeviceSum = {time: data.time};
    const keys = Object.keys(data).filter(elem => elem !== 'time');
    let other = 0;
    keys.forEach(key =>
      showVersions.includes(key) ? tempData[key] = data[key] : other += data[key] as number);

    if (other > 0) {
      tempData.other = other;
      hasOther = true;
    }
    return tempData;
  });
  if (hasOther) versions.push('other');

  return (
    <div>
      <div className={styles.chartTitle}>{unitLabel}:</div>
      <ResponsiveContainer width="100%" height={150}>
        <AreaChart data={deviceData} syncId="dashboard">
          <Tooltip wrapperStyle={{zIndex:1}} content={<ChartTooltip/>} position={{ y:-25 } as Coordinates} />
          {versions.map((vers, index)  =>
            <Area key={vers} type="monotone" dataKey={vers} name={vers}
              stroke={deviceDataColors[index]} fill={deviceDataColors[index]} stackId="1"
              strokeWidth={3} />) }
          {deployMarkerLines(deviceData)}
          <CartesianGrid stroke="#ccc" strokeDasharray="1 1" />
          <XAxis dataKey={(stat) => stat.time.toISOString()}
            tick={<GraphTimeTick />} stroke="#21a1b5"/>
          <YAxis axisLine={false} tickLine={false} tick={axisTickStyle}
            tickFormatter={tick => tick.toLocaleString()}/>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
});

export default DeviceChartWidget;
